// extracted by css-extract-rspack-plugin
export default {"root":"root-jhd9tC","label":"label-AFYsuy text-base-regular","value":"value-DJovLv text-base-semibold"};